import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { SignIn, useAuth } from "@clerk/clerk-react";
import { useSearchParams } from "react-router-dom";
import { useAuthToken } from "../lib/authToken";
import { API_URL } from "../lib/env";
export default function DesktopAuth() {
    const [params] = useSearchParams();
    const { isLoaded, isSignedIn } = useAuth();
    const getAuthToken = useAuthToken();
    const [status, setStatus] = useState("idle");
    const [message, setMessage] = useState("");
    const handedOff = useRef(false);
    const port = params.get("port");
    const state = params.get("state") ?? "";
    const validPort = port && /^\d{2,5}$/.test(port);
    useEffect(() => {
        if (!isLoaded || !isSignedIn || handedOff.current || !validPort)
            return;
        handedOff.current = true;
        (async () => {
            setStatus("exchanging");
            try {
                const clerkToken = await getAuthToken();
                if (!clerkToken)
                    throw new Error("No session token");
                const res = await fetch(`${API_URL}/desktop/auth/exchange`, {
                    method: "POST",
                    headers: { authorization: `Bearer ${clerkToken}` },
                });
                if (!res.ok)
                    throw new Error(`Exchange failed (${res.status})`);
                const { token } = (await res.json());
                // Hand the token back to the desktop app's loopback listener.
                const callback = new URL(`http://127.0.0.1:${port}/callback`);
                callback.searchParams.set("token", token);
                callback.searchParams.set("state", state);
                setStatus("done");
                window.location.replace(callback.toString());
            }
            catch (err) {
                setStatus("error");
                setMessage(err instanceof Error ? err.message : "Sign-in failed");
            }
        })();
    }, [isLoaded, isSignedIn, validPort, getAuthToken, port, state]);
    const shell = (children) => (_jsx("main", { className: "min-h-screen bg-black text-white flex items-center justify-center px-6 py-16", children: _jsx("div", { className: "w-full max-w-md text-center", children: children }) }));
    if (!validPort) {
        return shell(_jsx("p", { className: "text-white/70", children: "Open this page from the Evyely desktop app's sign-in button." }));
    }
    if (!isLoaded)
        return shell(_jsx("p", { className: "text-white/70", children: "Loading\u2026" }));
    if (!isSignedIn) {
        return (_jsx("main", { className: "min-h-screen bg-black text-white flex items-center justify-center px-6 py-16", children: _jsxs("div", { className: "w-full max-w-md", children: [_jsx("h1", { className: "text-2xl font-semibold text-center mb-6", children: "Sign in to Evyely Desktop" }), _jsx(SignIn, { routing: "hash", forceRedirectUrl: `/desktop-auth?port=${port}&state=${encodeURIComponent(state)}`, fallbackRedirectUrl: `/desktop-auth?port=${port}&state=${encodeURIComponent(state)}` })] }) }));
    }
    return shell(status === "error" ? (_jsxs(_Fragment, { children: [_jsx("h1", { className: "text-2xl font-semibold mb-3", children: "Couldn't finish sign-in" }), _jsx("p", { className: "text-red-300", children: message })] })) : (_jsxs(_Fragment, { children: [_jsx("h1", { className: "text-2xl font-semibold mb-3", children: "You're signed in \uD83C\uDF89" }), _jsx("p", { className: "text-white/70", children: "Returning to the Evyely desktop app\u2026 you can close this tab." })] })));
}
